module.exports = __webpack_public_path__ + "img/about-4.9b3cfd20.jpg";